import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as ArrowRight } from "icons/arrow-right.svg";
import { useHistory } from "react-router-dom";
import Subscription from "./Subscription";
import IconLeft from "./IconLeft";
import Title from "./Title";
import Info from "./Info";

type breadcrumbData = {
  name: string;
  active: boolean;
  path?: string;
};

type Props = {
  icon?: string;
  title?: string;
  breadcrumb: breadcrumbData[];
  children: React.ReactNode;
  info?: string | number;
  subInfo?: string;
  search?: boolean;
  subscriptionId?: string | undefined;
  paymentId?: string | undefined;
  groupName?: string;
  searchChildren?: React.ReactNode;
};

const Dashboard: React.FC<Props> = ({
  icon,
  title,
  breadcrumb,
  children,
  info,
  subInfo,
  search,
  subscriptionId,
  paymentId,
  groupName,
  searchChildren,
}): JSX.Element => {
  let history = useHistory();

  const [groupId, setGroupId] = useState();

  useEffect(() => {
    setGroupId(history.location.pathname.split("/")[2]);
  }, [history]);

  const returnBreadcrumb = (breadcrumb: breadcrumbData[]): JSX.Element => {
    return (
      <div className="flex flex-row">
        {breadcrumb.map((b: breadcrumbData, i, row) => (
          <Fragment key={i}>
            <div
              onClick={() => history.replace(b.path)}
              className={`flex flex-col font-sora text-base ${b.active ? "" : "cursor-pointer"}`}
              style={{
                fontStyle: "normal",
                fontWeight: 400,
                color: b.active ? "#408E5A" : "#8E8E8E",
              }}
            >
              {b.name}
            </div>
            {i + 1 === row.length ? <></> : <ArrowRight className="mx-2" />}
          </Fragment>
        ))}
      </div>
    );
  };

  const returnSubscription = (
    subscriptionId: any,
    paymentId: any
  ): JSX.Element => {
    if (!!paymentId || !!subscriptionId) {
      return (
        <Subscription
          subscriptionId={subscriptionId}
          paymentId={paymentId}
          groupId={groupId}
          groupName={groupName}
        />
      );
    }

    return <></>;
  };

  return (
    <main className="flex-1 overflow-x-hidden overflow-y-auto z-50 bg-bt-gray-000">
      <div className="container mx-auto px-8 py-10">
        {title && (
          <section className="">
            {breadcrumb.length > 0 ? returnBreadcrumb(breadcrumb) : ""}
            <div className="flex flex-row">
              {icon ? <IconLeft breadcrumb={breadcrumb} icon={icon} /> : ""}
              <Title
                breadcrumb={breadcrumb}
                title={title}
                subscriptionId={subscriptionId}
                paymentId={paymentId}
              />
              {returnSubscription(subscriptionId, paymentId)}
            </div>
          </section>
        )}
        <div
          className={`flex flex-row mt-6 ${info ? "justify-between" : "justify-end"
            }`}
        >
          {info ? subInfo && <Info info={info} subInfo={subInfo} /> : ""}
          {search ? (
            <div className="flex flex-col w-72">{searchChildren}</div>
          ) : (
            ""
          )}
        </div>
        {children}
      </div>
    </main>
  );
};

export default Dashboard;
